var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('img',{attrs:{"src":_vm.static_img_url + 'pic/pay-state.png?v=' + _vm.imgVersion}}),_c('p',{staticClass:"p1"},[_vm._v("Payment result is being confirmed. ")]),_c('p',{staticClass:"p2"},[_vm._v("Please do not close this page.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }